import React from 'react';
import cn from 'classnames';

import styles from './index.module.scss';

interface GradientTextProps {
  text: string;
  className?: string;
  speed?: number;
}

export const GradientText: React.FC<GradientTextProps> = ({ text, className = '' }) => {
  return <span className={cn(styles.boujeeText, className)}>{text}</span>;
};
